import { createContext, useState, useContext } from "react";

const DialogContext = createContext(null);

export const DialogProvider = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <DialogContext.Provider value={{ dialogOpen, setDialogOpen }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => useContext(DialogContext);
